import type { Appointment } from '@/lib/api'
import { clientColor } from './clientColors'

export const SLOT_HEIGHT = 48 // px per 30 minutes
export const DAY_START_HOUR = 8
export const DAY_END_HOUR = 24
export const MINUTES_PER_SLOT = 30
export const SLOTS_PER_HOUR = 60 / MINUTES_PER_SLOT
export const NIGHT_START_HOUR = 22
export const NIGHT_END_HOUR = 8 // 次日
export const COMPRESSED_NIGHT_HEIGHT = 48 // 周视图夜间压缩为一格的高度(px)

export const STATUS_VARIANT: Record<
  Appointment['status'],
  'default' | 'success' | 'warning' | 'danger' | 'secondary'
> = {
  scheduled: 'default',
  completed: 'success',
  cancelled: 'secondary',
  late_cancelled: 'warning',
  no_show: 'danger',
}

/**
 * 非 scheduled 状态色（OPT-014）：
 * completed 绿 / no_show 红 / cancelled 灰 / late_cancelled 黄
 * 日历块、详情色点、列表徽章一律从这里取色，禁止各组件自备色值。
 */
export const STATUS_COLORS = {
  completed: '#10B981',
  no_show: '#EF4444',
  cancelled: '#94A3B8',
  late_cancelled: '#EAB308',
} as const

/** 课程块/色点颜色单一来源：scheduled 用学员色板，其余状态用状态色 */
export function eventColor(appt: Pick<Appointment, 'status' | 'clientId'>): string {
  if (appt.status === 'scheduled') return clientColor(appt.clientId)
  return STATUS_COLORS[appt.status]
}
